import { Button } from 'antd';
import { Modal_UI_UserSelection as ModalUI } from 'components/ui';
import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { setSelectedUsers } from '../flow/actions';

const defaultProps = {};
const propTypes = {
  data: PropTypes.array.isRequired
};

class SharedToUsers extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      checkedValues: props.selectedValues
    };
  }
  // Simple diff and sync store with local state
  componentWillReceiveProps(nextProps) {
    if (this.props.selectedValues !== nextProps.selectedValues) {
      this.setState({
        checkedValues: nextProps.selectedValues
      });
    }
  }

  handleBtnClick = () => this.setState({ visible: true });
  // Revert changes and close modal
  handleModalCancelClick = () => {
    this.setState({
      visible: false,
      checkedValues: this.props.selectedValues
    });
  };
  // Sync changes to store, update local state and close modal
  handleModalOkClick = () => {
    const { checkedValues } = this.state;
    const selectedUsers = this.props.data.filter(
      u => checkedValues.indexOf(u.id) > -1
    );
    this.props.setSelectedUsers(selectedUsers);
    this.setState({ visible: false });
  };
  // Sync state with inner selection in modal
  handleSharedToChange = (changedId, e) => {
    const { checkedValues } = this.state;
    if (checkedValues.indexOf(changedId) > -1) {
      return this.setState({
        checkedValues: checkedValues.filter(cv => cv !== changedId)
      });
    }
    return this.setState({
      checkedValues: [...checkedValues, changedId]
    });
  };

  render() {
    const { checkedValues, visible } = this.state;
    const { data } = this.props;
    return (
      <Fragment>
        <Button
          size="small"
          className="report-theme-btn"
          onClick={this.handleBtnClick}
        >
          <FormattedMessage id="global.ui.button.addUserToShare" />
        </Button>
        <ModalUI
          visible={visible}
          data={data}
          onOk={this.handleModalOkClick}
          onCancel={this.handleModalCancelClick}
          onChange={this.handleSharedToChange}
          checkedValues={checkedValues}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ sharableObjects, reportList }) => {
  const activeFolder = [
    ...reportList.folders.report,
    ...reportList.folders.dashboard
  ].find(f => f.isActive);

  const selectedValues = activeFolder
    ? activeFolder.sharedToUsers.map(u => u.id)
    : [];

  return {
    data: sharableObjects.users,
    selectedValues
  };
};
const mapDispatchToProps = {
  setSelectedUsers
};
SharedToUsers.defaultProps = defaultProps;
SharedToUsers.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharedToUsers);



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/components/SharedToUsers.jsx